<template>
  <div>
    <NuxtRouteAnnouncer />
    <StatusAnnouncer />
    <Lottieloader v-if="$isLoading" />
    
    <div v-show="!$isLoading">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
      <ChatLauncher />
    </div>
  </div>
</template>

<script setup lang="ts">
import StatusAnnouncer from './components/layout/StatusAnnouncer.vue';
import Lottieloader from './components/loader/Lottieloader.vue';
import ChatLauncher from './components/support/ChatLauncher.vue';

const nuxtApp = useNuxtApp()
const { $isLoading } = nuxtApp

// A client-side navigation swaps the page out without moving focus, so a keyboard or screen-reader
// user stays wherever the previous page left them. `page:finish` is the first point where the new
// page is rendered and the loader has released the layout, so `#main-content` can take focus; the
// initial render is skipped because focus already starts at the top of the document.
if (import.meta.client) {
  let isFirstRender = true

  nuxtApp.hook('page:finish', () => {
    if (isFirstRender) {
      isFirstRender = false
      return
    }

    void nextTick(() => document.getElementById('main-content')?.focus())
  })
}

// Titles are set per-page; no global useHead title here
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.nuxt-loading-indicator {
  display: none !important;
}
/* The post-navigation focus move is programmatic; only a keyboard-driven focus shows a ring. */
#main-content:focus:not(:focus-visible) {
  outline: none;
}
</style>
